import { CONTRACT_REMINDER_STATUS_COLOR } from '@constants/contract-reminder-color.constant';
import { CONTRACT_REMINDER_STATUS_LABEL } from '@constants/contract-reminder-label.constant';
import { CONTRACT_STATUS_COLOR } from '@constants/contract-status-color.constant';
import { CONTRACT_STATUS_LABEL } from '@constants/contract-status-label.constant';
import { DECLARATION_STATUS_COLOR } from '@constants/declaration-status-color.constant';
import { DECLARATION_STATUS_LABEL } from '@constants/declaration-status-label.constant';
import { DIRECTOR_REMUNERATION_STATUS_COLOR } from '@constants/director-remuneration-status-color.constants';
import { DIRECTOR_REMUNERATION_STATUS_LABEL } from '@constants/director-remuneration-status-label.constants';
import { INVOICE_STATUS_COLOR } from '@constants/invoice-status-color.constant';
import { INVOICE_STATUS_LABEL } from '@constants/invoice-status-label.constant';
import { MISSION_ACCEPTANCE_STATUS_COLOR } from '@constants/mission-acceptance-status-color.constant';
import { MISSION_ACCEPTANCE_STATUS_LABEL } from '@constants/mission-acceptance-status-label.constant';
import { TASK_PLANNING_INVOICING_STATUS_COLOR } from '@constants/task-planning-invoicing-status-color.constant';
import { TASK_PLANNING_INVOICING_STATUS_LABEL } from '@constants/task-planning-invoicing-status-label.constant';
import { DeclarationStatus } from '@enums/declaration-status.enum';
import { DirectorRemunerationStatus } from '@enums/director-remuneration-status.enum';
import { InvoiceStatus } from '@enums/invoice-status.enum';
import { MissionAcceptanceStatus } from '@enums/mission-acceptance-status.enum';
import { StatusColor } from '@enums/status-color.enum';
import { TaskPlanningInvoicingStatusCode } from '@enums/task-planning-invoicing-status-code.enum';
import { ContractReminderStatus } from '@gi/enums/contract-reminder-status.enum';
import { ContractStatus } from '@gi/enums/contract-status.enum';
import { LegalFormalityAccountsApprovalEnum } from '@legal/legal-core/enums/legal-formality-accounts-approval.enum';
import { LegalFormalityCreationEnum } from '@legal/legal-core/enums/legal-formality-creation.enum';
import { LEGAL_ACCOUNTS_APPROVAL_STATUS_COLOR } from '@modules/core/constants/legal-accounts-approval-status-color.constant';
import { LEGAL_ACCOUNTS_APPROVAL_STATUS_LABEL } from '@modules/core/constants/legal-accounts-approval-status-label.constant';
import { StatusType } from '@modules/core/types/status-type.type';
import { Status } from '@modules/core/types/status.type';

import { LEGAL_CREATION_STATUS_COLOR } from './legal-creation-status-color.constant';
import { LEGAL_CREATION_STATUS_LABEL } from './legal-creation-status-label.constant';

export const STATUS_TYPE: Record<StatusType, (status: Status) => { label: string; color: StatusColor }> = {
  contractReminder: (status: ContractReminderStatus) => ({
    label: CONTRACT_REMINDER_STATUS_LABEL[status],
    color: CONTRACT_REMINDER_STATUS_COLOR[status]
  }),
  declaration: (status: DeclarationStatus) => ({
    label: DECLARATION_STATUS_LABEL[status],
    color: DECLARATION_STATUS_COLOR[status]
  }),
  taskPlanningInvoicing: (status: TaskPlanningInvoicingStatusCode) => ({
    label: TASK_PLANNING_INVOICING_STATUS_LABEL[status],
    color: TASK_PLANNING_INVOICING_STATUS_COLOR[status]
  }),
  contract: (status: ContractStatus) => ({
    label: CONTRACT_STATUS_LABEL[status],
    color: CONTRACT_STATUS_COLOR[status]
  }),
  invoice: (status: InvoiceStatus) => ({
    label: INVOICE_STATUS_LABEL[status],
    color: INVOICE_STATUS_COLOR[status]
  }),
  missionAcceptance: (status: MissionAcceptanceStatus) => ({
    label: MISSION_ACCEPTANCE_STATUS_LABEL[status],
    color: MISSION_ACCEPTANCE_STATUS_COLOR[status]
  }),
  legalAccountsApprovalStatus: (status: LegalFormalityAccountsApprovalEnum) => ({
    label: LEGAL_ACCOUNTS_APPROVAL_STATUS_LABEL[status],
    color: LEGAL_ACCOUNTS_APPROVAL_STATUS_COLOR[status]
  }),
  legalCreationStatus: (status: LegalFormalityCreationEnum) => ({
    label: LEGAL_CREATION_STATUS_LABEL[status],
    color: LEGAL_CREATION_STATUS_COLOR[status]
  }),
  directorRemuneration: (status: DirectorRemunerationStatus) => ({
    label: DIRECTOR_REMUNERATION_STATUS_LABEL[status],
    color: DIRECTOR_REMUNERATION_STATUS_COLOR[status]
  })
};
